import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Scrollbar from "react-scrollbars-custom";
import ReactTooltip from 'react-tooltip';
import dayjs from "dayjs";
import { useReward } from 'react-rewards';

import config from "config/common";
import lib from "lib/commons";

Modal.setAppElement("#root");

const ModalReceivedGifts = ({
  modalStatus,
  closeModal,
  gifts
}) => {
  const {reward: confettiReward3, isAnimating: isConfettiAnimating3} = useReward('confettiReward', 'confetti', {elementCount: 500, zIndex: 20, elementSize: 12, spread: 360});

  useEffect(() => {
    ReactTooltip.rebuild();
  })

  useEffect(() => {
    const checkJackpot = gifts.find(item => item?.spin_result_type != 1)

    if(checkJackpot) {
      setTimeout(() => {
        // document.querySelector(".confetti").click()
        document.getElementById("confetti3").click()
      }, 1000);
    }
  }, [gifts])

  const afterOpenModal = () => {};

  const selfClose = (event) => {
    event.preventDefault();
    closeModal();
  };

  return (
    <Modal
      isOpen={modalStatus}
      onAfterOpen={afterOpenModal}
      onRequestClose={selfClose}
      contentLabel="Example Modal"
      portalClassName="ReactModalPortal"
      overlayClassName=""
      className="animated fadeInDown faster modal-received-gifts"
    >
      <h2>
        <img src="/images/title-congrat.png" alt="" className="title-modal"/>
      </h2>
      <div className="modal-description">
        <div className="received-gifts">
          <Scrollbar style={{ height: '36vw' }} noScrollX={true} >
            <div className="received-gifts__list">
              {gifts.length > 0 && gifts.map((gift, index) => {
                return (
                  <div className="received-gifts__items" key={index}>
                    <div className="received-gifts__item">
                      <div className="received-gifts__left">
                        <div className="received-gifts__medal">
                          {gift?.items.length > 0 && gift?.items.map((item, index) => {
                            return (
                              <div>
                                <img src={`/images/medal${item}.png`} alt="" />
                              </div>
                            )
                          })}
                        </div>
                        <div className="received-gifts__time">
                          {/* {dayjs(gift?.current_datetime).format("HH:mm - DD.MM.YYYY")} */}
                          {gift?.reward_name}
                        </div>
                      </div>
                      <div className="received-gifts__right">
                        <div className="received-gifts__reward">
                          <img src={gift?.image} alt="" data-tip={gift?.reward_name} />
                        </div>
                        <div className="point">
                          <img src="/images/star.png?v=1" alt="" />
                          <span>+{gift?.accumulation_point}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </Scrollbar>
          <button
            disabled={isConfettiAnimating3}
            onClick={() => {
                confettiReward3();
            }}
            className="confetti"
            id="confetti3"
          >
            <span id="confettiReward" />
          </button>
        </div>
      </div>
      <ReactTooltip html={true} />
    </Modal>
  )
}

export default ModalReceivedGifts